import React, { type ComponentPropsWithoutRef } from "react";
import { Slot } from "@radix-ui/react-slot";
import { cn } from "@/lib/utils";

export interface ContentActionSlots {
  content: React.ReactNode;
  actions: React.ReactNode;
}

interface LayoutPartProps extends ComponentPropsWithoutRef<"div"> {
  asChild?: boolean;
}

/** The shell owns height; only Content (or its nested list) owns scrolling. */
export const ScrollableActionLayout = ({
  asChild = false,
  className,
  ...props
}: LayoutPartProps): React.ReactNode => {
  const Component = asChild ? Slot : "div";
  return (
    <Component
      className={cn("flex min-h-0 flex-1 flex-col", className)}
      {...props}
    />
  );
};

export const ScrollableActionContent = ({
  asChild = false,
  scroll = "native",
  className,
  ...props
}: LayoutPartProps & {
  scroll?: "native" | "external";
}): React.ReactNode => {
  const Component = asChild ? Slot : "div";
  return (
    <Component
      className={cn(
        "min-h-0",
        scroll === "native" && "overflow-y-auto overscroll-contain",
        className
      )}
      {...props}
    />
  );
};

export const ScrollableActionActions = ({
  asChild = false,
  className,
  ...props
}: LayoutPartProps): React.ReactNode => {
  const Component = asChild ? Slot : "div";
  return <Component className={cn("shrink-0", className)} {...props} />;
};
